import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  userService,
  vmDataService,
  vmSharedModelService
} from 'app/services';
import vendorManagementNavigationService from '../services';
import controller from './notifications.controller';
import directive from './notifications.directive';
import sendNotificationsDialog from './dialog.sendNotificationsDialog';

export default angular.module('app.components.advisory.vendorManagement.notifications', [
  constants,
  loaderService,
  userService,
  vmDataService,
  vendorManagementNavigationService,
  vmSharedModelService,
  sendNotificationsDialog,
])
  .directive('vmNotifications', directive)
  .controller('NotificationsController', controller)
  .name;

console.log('app.components.advisory.vendorManagement.notifications created');
